import { Quote } from "@/shared/types/Quote.interface";
import { QuoteDataUtils } from "@/shared/utils/QuoteDataUtils";
import { UIUtils } from "@/shared/utils/UIUtils";
import { PartialPolicyStepType } from "../schema/PtzCaQuote";

export class PtzCaDataUtils {
    /**
     * The API stores CA postals without the space ("T3J3E6") but PolicyStepSchema's regex and the
     * form inputs expect the masked format ("T3J 3E6"). Pass this as `formatRatingZipcode` to every
     * `petQuoteToQuote` call on a CA quote — an unmasked rehydrated postal fails step validation,
     * which kicks returning users back to the Pets step.
     */
    static formatRatingZipcode = (value: string) => UIUtils.maskPostalCodeCA(value);

    static getPolicyStepInitialValues(quote?: Quote): PartialPolicyStepType {
        // Destructure existing values from quote
        const { email, ratingZipcode, phone, policies, extra, id, marketing, firstName, lastName } = quote || {};

        // Use existing values if available, otherwise fall back to defaults
        const initialValues: PartialPolicyStepType = {
            firstName: firstName || "",
            lastName: lastName || "",
            email: email || "",
            ratingZipcode: PtzCaDataUtils.formatRatingZipcode(ratingZipcode || ""),
            phone: phone || "",
            policies: !!id && policies?.length ? policies : [QuoteDataUtils.createNewPolicyCA()],
            marketing: {
                hasEmailConsent: marketing?.hasEmailConsent ?? false,
                hasSMSConsent: marketing?.hasSMSConsent ?? false
            },
            extra: {
                ...extra,
                policyStepConsented: extra?.policyStepConsented ?? false
            }
        };

        return initialValues;
    }
}
